import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-bb.png'


import HeaderComponent from '@/components/HeaderComponent.vue'
import InfoCardComponent from '@/components/InfoCardComponent.vue'
import RefresherComponent from '@/components/RefresherComponent.vue'
import TileCol from '@/components/TileCol.vue'
import { useAppConfig, useAppSettings } from '@/composables/app'
import { useApplicants, useCurrentUserProfile } from '@/composables/userProfile'
import { USER_ROLES } from '@/constants'
import { IonCol, IonContent, IonGrid, IonPage, IonRow } from '@ionic/vue'
import { computed } from 'vue'

// Composables


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const userProfile = useCurrentUserProfile()
const appSettings = useAppSettings()
const appConfig = useAppConfig()
const applicants = useApplicants(15)

// Computed vars
const attendantSchedule = computed(() => appConfig.value?.attendantSchedule ?? [])
const showPendingRequestInfo = computed(() => {
  if (!userProfile.value) return false
  return userProfile.value.role === USER_ROLES.Newbie && userProfile.value.hasDoneOnboarding
})
const showSelectTeam = computed(() => {
  if (!userProfile.value) return false
  return userProfile.value.role === USER_ROLES.Participant && !userProfile.value.teamId
})
const showMyGroupButton = computed(() => {
  if (!userProfile.value) return false
  return userProfile.value.role === USER_ROLES.Participant && userProfile.value.groupId
})
const showRegisterAttendants = computed(() => {
  if (!userProfile.value) return false
  if (!appSettings.value || !appSettings.value.isAttendantRegistrationOpen) return false
  return userProfile.value.role === USER_ROLES.Chef
})
const nbApplicants = computed(() => {
  if (!applicants.value) return 0
  return applicants.value.length <= 15 ? applicants.value.length : '15+'
})
const requestValidator = computed(() => {
  if (!userProfile.value) return ''
  switch (userProfile.value.requestedRole) {
    case USER_ROLES.Animateur:
    case USER_ROLES.Chef:
      return 'chef•fe de ta section'
    case USER_ROLES.Organisateur:
      return 'orga de la Baden Battle'
    case USER_ROLES.Administrateur:
      return 'admin de l\'app'
    default:
      return ''
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(HeaderComponent, { "page-title": "Accueil" }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(RefresherComponent),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "homepage-logo" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Logo Baden Battle"
            })
          ], -1)),
          (showPendingRequestInfo.value)
            ? (_openBlock(), _createBlock(InfoCardComponent, {
                key: 0,
                class: "ion-margin-horizontal"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Ton inscription est en attente de validation par un•e " + _toDisplayString(requestValidator.value) + ". N'hésite pas à les contacter pour accélérer ta demande. ", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(userProfile))
            ? (_openBlock(), _createBlock(_unref(IonGrid), {
                key: 1,
                class: "home-grid"
              }, {
                default: _withCtx(() => [
                  (_unref(userProfile).role === _unref(USER_ROLES).Animateur || _unref(userProfile).role === _unref(USER_ROLES).Chef)
                    ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attendantSchedule.value, (timeSlot) => {
                            return (_openBlock(), _createBlock(_unref(IonCol), {
                              key: timeSlot.id,
                              size: "6",
                              "size-sm": "4",
                              "size-lg": "2"
                            }, {
                              default: _withCtx(() => [
                                (_unref(userProfile).games && _unref(userProfile).games[timeSlot.id])
                                  ? (_openBlock(), _createBlock(TileCol, {
                                      key: 0,
                                      size: "12",
                                      target: `/game/${_unref(userProfile).games[timeSlot.id].id}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Mon épreuve (" + _toDisplayString(timeSlot.name) + ") ", 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["target"]))
                                  : (_unref(appSettings) && _unref(appSettings).isAttendantRegistrationOpen)
                                    ? (_openBlock(), _createBlock(TileCol, {
                                        key: 1,
                                        size: "12",
                                        target: "/games"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Inscris-toi à une épreuve (" + _toDisplayString(timeSlot.name) + ") ", 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonRow), null, {
                    default: _withCtx(() => [
                      (showSelectTeam.value)
                        ? (_openBlock(), _createBlock(TileCol, {
                            key: 0,
                            target: `/player-group/${_unref(userProfile).groupId}`
                          }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                              _createTextVNode(" Choisis une équipe ")
                            ])),
                            _: 1
                          }, 8, ["target"]))
                        : _createCommentVNode("", true),
                      (showMyGroupButton.value)
                        ? (_openBlock(), _createBlock(TileCol, {
                            key: 1,
                            target: `/player-group/${_unref(userProfile).groupId}`
                          }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode(" Ma section ")
                            ])),
                            _: 1
                          }, 8, ["target"]))
                        : _createCommentVNode("", true),
                      (_unref(userProfile).teamId)
                        ? (_openBlock(), _createBlock(TileCol, {
                            key: 2,
                            target: `/team/${_unref(userProfile).teamId}`
                          }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode(" Mon équipe ")
                            ])),
                            _: 1
                          }, 8, ["target"]))
                        : _createCommentVNode("", true),
                      (nbApplicants.value)
                        ? (_openBlock(), _createBlock(TileCol, {
                            key: 3,
                            target: "/applicants"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(nbApplicants.value) + " demande" + _toDisplayString(typeof nbApplicants.value == 'string' || nbApplicants.value > 1 ? 's' : '') + " d'accès ", 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (showRegisterAttendants.value)
                        ? (_openBlock(), _createBlock(TileCol, {
                            key: 4,
                            target: `/attendant-group/${_unref(userProfile).groupId}`
                          }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode(" Inscris tes animés à des épreuves ")
                            ])),
                            _: 1
                          }, 8, ["target"]))
                        : _createCommentVNode("", true),
                      (_unref(userProfile).role >= _unref(USER_ROLES).Animateur && _unref(userProfile).groupId)
                        ? (_openBlock(), _createBlock(TileCol, {
                            key: 5,
                            target: `/attendant-group/${_unref(userProfile).groupId}`
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" Ma section ")
                            ])),
                            _: 1
                          }, 8, ["target"]))
                        : _createCommentVNode("", true),
                      (_unref(userProfile).role >= _unref(USER_ROLES).Organisateur)
                        ? (_openBlock(), _createBlock(TileCol, {
                            key: 6,
                            target: "/attendant-group"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode(" Animateurs ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})